/* eslint-disable jsx-a11y/anchor-is-valid */
import './styles.scss'
import React, { useState } from 'react'
import { I18n } from 'react-redux-i18n'

import { sentimentAPI } from 'api'
import ReactionIcons from 'components/ReactionIcons'
import ReplyEditor from 'components/Chat/ReplyEditor'
import { getStaticImage } from 'utils/statics'
import { getChannelKey } from 'constants/channels'
import { MenuDotsOptions, UserAvatar } from 'components/common'
import { lang } from 'utils/helpers'
import HashtagsManager from 'components/HashtagsManager'

function ButtonsPost({ buttons }) {
  if (!Array.isArray(buttons) || !buttons.length) return null

  return buttons.map((btn, idx) => (
    <div key={`button-${idx}`} className={`message-buttons new-size-font button-${buttons.length}`}>
      <span className='post-comment__content-postback-label'>{btn.label}:</span>
      <a className='post-comment__content-postback-url postback-link-disable'>{btn.content}</a>
    </div>
  ))
}

const PostComment = ({
  id,
  userId,
  messageId,
  operatorId,
  type,
  avatar,
  name,
  profile,
  sentiment = {},
  sentimentList = [],
  isRemoved = false,
  content,
  reactions,
  time,
  labels,
  assignedLabels,
  channel,
  fatherBranch,
  childBranch,
  multipleBranch,
  handleDeleteComment,
  handleSaveLabels,
  saveLabelsRefreshCount,
}) => {
  const [isOpenReplayEditor, setIsOpenReplayEditor] = useState(false)
  const [isOpenRemoveModal, setIsOpenRemoveModal] = useState(false)
  const [isOpenHashtagsManager, setIsOpenHashtagsManager] = useState(false)

  const toggleHashtagsManager = () => setIsOpenHashtagsManager(!isOpenHashtagsManager)

  return (
    <div
      id={id}
      className={`
        post-comment
        ${fatherBranch ? 'post-comment--fatherBranch' : ''}
        ${childBranch ? 'post-comment--childBranch' : ''}
        ${multipleBranch ? 'post-comment--multipleBranch' : ''}
        ${type ? type : '' }
      `}
    >
      <div
        className={`
          post-comment__header
          ${fatherBranch ? 'post-comment__header--fatherBranch' : ''}
          ${childBranch ? 'post-comment__header--childBranch' : ''}
          ${multipleBranch ? 'post-comment__header--multipleBranch' : ''}
        `}
      >
        <UserAvatar
          avatar={avatar}
          channel={getChannelKey(channel)}
          sentiment={{
            value: sentiment.value,
            score: sentiment.score,
            sentimentList
          }}
          onChangeSentiment={value => sentimentAPI.change({
            userId,
            nodeId: id,
            operatorId,
            data: { sentiment: value }
          })}
          onErrorAvatar={event => {
            event.target.src = getStaticImage('/icons/orange-brand/icon-avatar.svg')
            event.onerror = null
          }}
        />
      </div>
      <div className='post-comment__body'>
        <div className={`post-comment__content ${type === 'note' ? 'post-comment__content--note' : ''}`}>
          {name ? (
            <p
              title={name}
              className='post-comment__username text-ellipsis'
              style={{ cursor: profile ? 'pointer' : null }}
              onClick={() => profile ? window.open(profile, '_blank', 'noopener noreferrer') : null}
            >
              {name}
            </p>
          ) : null}
          {content?.messageText && (
            <p
              className={`post-comment__content-text ${isRemoved ? 'post-comment__content-delete':''}`}
              style={{ marginTop: !name ? '5px' : null }}
              dangerouslySetInnerHTML={{ __html: isRemoved ? lang(type === 'note' ? 'note_deleted' :'comment_delete' ): content.messageText }}
            />
          )}
          { !isRemoved && (
            <ButtonsPost
              buttons={content?.buttons | []}
            />
          )}
          <div className='post-comment__content-reaction-icons-container'>
            <ReactionIcons
              withBackground
              reactions={reactions}
            />
          </div>
        </div>
        {!content?.isRemoved && content?.attachments?.length > 0 && (
          <div className='post-comment__attachments'>
            {content.attachments.map((attachment, index) => {
              if (['image', 'photo'].includes(attachment.mimeType)) {
                return (
                  <a key={index} href={content?.attachments?.[0]?.url} target='_blank' rel='noopener noreferrer'>
                    <figure>
                      <img src={content?.attachments?.[0]?.url} alt='Attachment' />
                    </figure>
                  </a>
                )
              }
              if (attachment.mimeType === 'video') {
                return (
                  <a key={index} href={content?.attachments?.[0]?.url} target='_blank' rel='noopener noreferrer'>
                    <video>
                      <source src={content?.attachments?.[0]?.url} type='video/mp4' />
                      {I18n.t('dashboard_video_notSupported')}
                    </video>
                  </a>
                )
              }
              return null
            })}
          </div>
        )}
        <div className='post-comment__options'>
          {(type !== 'note' && !isRemoved) && (
            <button className='post-comment__btn' onClick={() => setIsOpenReplayEditor(!isOpenReplayEditor)}>
              {I18n.t('dashboard_reply')}
            </button>
          )}
          <span className='post-comment__time'>{time}</span>
          <button className='post-comment__btn' onClick={toggleHashtagsManager}>#</button>
          {(!isRemoved && type === 'operator') ? (
            <MenuDotsOptions
              typeOptions={'iconButton'}
              onClickButton={() => setIsOpenRemoveModal(true)}
              isOpenModalDelete={isOpenRemoveModal}
              toggleDelete={() => {
                setIsOpenRemoveModal(!isOpenRemoveModal)
              }}
              type={type === 'note' ? type: 'comment'}
              eventDelete={() =>{
                handleDeleteComment({ commentId: id, userId })
                setIsOpenRemoveModal(!isOpenRemoveModal)
              }}
            />
          ) : null}
        </div>
        <HashtagsManager
          isOpen={isOpenHashtagsManager}
          toggle={toggleHashtagsManager}
          hashtags={labels?.map(({ category, name }) => ({ value: category, label: name }))}
          currentHashtags={assignedLabels?.map(({ category, name }) => ({ value: category, label: name }))}
          onSave={values => handleSaveLabels({
            userId, messageId, labels: values
          })}
          refresh={saveLabelsRefreshCount}
        />
        <ReplyEditor
          key={`reply-${id}`}
          reaplyId={id}
          isOpenReplayEditor={isOpenReplayEditor}
          setIsOpenReplayEditor={setIsOpenReplayEditor}
          channel={channel}
        />
      </div>
    </div>
  )
}

export default PostComment
